import { render, staticRenderFns } from "./payableDetail.vue?vue&type=template&id=8a8df7ae&scoped=true"
import script from "./payableDetail.vue?vue&type=script&lang=js"
export * from "./payableDetail.vue?vue&type=script&lang=js"
import style0 from "./payableDetail.vue?vue&type=style&index=0&id=8a8df7ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8df7ae",
  null
  
)

export default component.exports